var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.57735C9.6188 0.220085 10.3812 0.220085 11 0.57735L18.5263 4.92265C19.1451 5.27992 19.5263 5.94017 19.5263 6.6547V15.3453C19.5263 16.0598 19.1451 16.7201 18.5263 17.0774L11 21.4226C10.3812 21.7799 9.6188 21.7799 9 21.4226L1.47372 17.0774C0.854918 16.7201 0.473721 16.0598 0.473721 15.3453V6.6547C0.473721 5.94017 0.854918 5.27992 1.47372 4.92265L9 0.57735Z",
    fill: "#0048FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallPolygon);
export default __webpack_public_path__ + "static/media/small_polygon.c9d001b4ab37327c1d26e9b74bc628e9.svg";
export { ForwardRef as ReactComponent };